<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Admin IPs</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>IP</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="ip in ips" v-if="ips.length" class="text-left">
                        <td>{{ ip.ip_address }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteIp(ip)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="2">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="2">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
    </v-container>

    <Create-ip v-if="createDialogSwitch" v-model="createDialogSwitch" @addIp="addIp"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import CreateIp from "@/components/dialogs/ips/Create.vue";

const createDialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();
const loading = ref(true);
const ips = ref([]);

onMounted(() => {
    fetchIps();
});

const fetchIps = () => {
    send('get', `admin/ip-addresses`)
        .then((response) => {
            ips.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar(error.response?.data?.message || 'IPs could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addIp = (ip) => {
    let updated = false
    if (ips.value.length) {
        ips.value.map((val, index) => {
            if (val.id === ip.id) {
                updated = true
                ips.value[index] = ip;
            }
        });
    }
    if (!updated) {
        ips.value.unshift(ip);
    }
}
const deleteIp = (ip) => {
    if (confirm(`Are you sure to delete "${ip.ip}" ip?`)) {
        send('delete', `admin/ip-addresses/${ip.id}`)
            .then((response) => {
                if (response.data.success) {
                    ips.value.map((item, index) => {
                        if (item.id === ip.id) {
                            ips.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${ip.title}" IP could not be deleted`, 'error')
                }
            })
    }
}
</script>
